<div class="tc-outer" (click)="deselectAll()">

  <!-- Canvas paper -->
  <div
    #canvasEl
    class="tc-canvas"
    [class.tc-canvas--grid]="showGrid"
    [class.tc-canvas--drag-over]="isDragOver"
    [style.width.px]="canvasWidthPx"
    [style.height.px]="canvasHeightPx"
    [attr.data-scale]="scale"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onNativeDrop($event)"
    (mousedown)="onCanvasMouseDown($event)"
    (click)="deselectAll()">

    <!-- Grid overlay -->
    <div class="tc-grid" *ngIf="showGrid"
      [style.background-size]="(5 * scale) + 'px ' + (5 * scale) + 'px'">
    </div>

    <!-- Rubber-band selection rectangle -->
    <div class="tc-rubber-band" *ngIf="rubberBandStyle" [style]="rubberBandStyle"></div>

    <!-- Drop hint -->
    <div class="tc-drop-hint" *ngIf="sortedElements.length === 0 && !isDragOver">
      <i class="pi pi-arrows-alt"></i>
      <p>{{ 'bikeshop.receipt_template.canvas.drag_hint' | translate }}</p>
    </div>

    <!-- Elements -->
    <app-canvas-element
      *ngFor="let element of sortedElements; trackBy: trackById"
      [element]="element"
      [isSelected]="isSelected(element)"
      [previewMode]="previewMode"
      [customData]="customData"
      [scale]="scale"
      [canvasWidthMm]="template.widthMm"
      [canvasHeightMm]="template.heightMm"
      [snapToGrid]="showGrid"
      [disableDrag]="selectedElements.length > 1"
      [showHandles]="selectedElements.length <= 1"
      [originalYMm]="getOriginalY(element.id)"
      (elementClicked)="selectElement(element, $event)"
      (moved)="elementMoved.emit($event)"
      (moveEnded)="elementMoveEnded.emit($event)"
      (removed)="elementRemoved.emit($event)"
      (contentChanged)="elementContentChanged.emit($event)"
      (contentResized)="scheduleMeasurement()">
    </app-canvas-element>

  </div>

  <!-- Dimension badge -->
  <div class="tc-dim-badge">
    {{ template.widthMm }} × {{ template.heightMm }} mm &nbsp;|&nbsp; {{ zoom }}%
  </div>

</div>
